import React, { useState, useEffect } from 'react';

const ITEMS = [
  { type: 'img', src: '/media/img1.jpg', alt: 'Tesisat çalışması', caption: 'Profesyonel montaj' },
  { type: 'img', src: '/media/img2.jpg', alt: 'Boru tesisatı', caption: 'PPR boru kurulumu' },
  { type: 'vid', src: '/media/video1.mp4', caption: 'Sahadan çalışma görüntüleri' },
  { type: 'img', src: '/media/img3.jpg', alt: 'Su tesisatı', caption: 'Su hattı yenileme' },
  { type: 'img', src: '/media/img4.jpg', alt: 'Tesisat detay', caption: 'Hassas işçilik' },
  { type: 'img', src: '/media/img5.jpg', alt: 'Boru montajı', caption: 'Boru bağlantısı' },
  { type: 'vid', src: '/media/video2.mp4', caption: 'Tesisat yenileme süreci' },
  { type: 'img', src: '/media/img6.jpg', alt: 'Tesisat projesi', caption: 'Proje kurulumu' },
  { type: 'img', src: '/media/img7.jpg', alt: 'Tesisat tamirat', caption: 'Tamir & bakım' },
  { type: 'img', src: '/media/img8.jpg', alt: 'Komple tesisat', caption: 'Komple yenileme' },
  { type: 'img', src: '/media/img9.jpg', alt: 'Kaliteli işçilik', caption: 'Saha çalışması' },
];

const TOTAL = ITEMS.length;

function getPos(i, active) {
  let d = i - active;
  if (d > TOTAL / 2) d -= TOTAL;
  if (d < -TOTAL / 2) d += TOTAL;
  return d;
}

const navBtn = (extra = {}) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'rgba(0,0,0,0.55)',
  backdropFilter: 'blur(8px)',
  border: '1px solid rgba(255,255,255,0.15)',
  color: 'white',
  fontSize: '26px',
  width: '52px',
  height: '52px',
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20,
  transition: 'background 0.2s',
  ...extra,
});

export default function GallerySection() {
  const [active, setActive] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const touchStartX = React.useRef(null);

  const prev = () => setActive(a => (a - 1 + TOTAL) % TOTAL);
  const next = () => setActive(a => (a + 1) % TOTAL);

  const handleItemClick = (i) => {
    if (i === active) setLightbox(active);
    else setActive(i);
  };

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) diff > 0 ? next() : prev();
    touchStartX.current = null;
  };

  useEffect(() => {
    const onKey = (e) => {
      if (lightbox !== null) {
        if (e.key === 'ArrowLeft') setLightbox(l => (l - 1 + TOTAL) % TOTAL);
        if (e.key === 'ArrowRight') setLightbox(l => (l + 1) % TOTAL);
        if (e.key === 'Escape') setLightbox(null);
      } else {
        if (e.key === 'ArrowLeft') prev();
        if (e.key === 'ArrowRight') next();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox]);

  return (
    <section className="section" style={{ background: 'var(--bg-secondary)', overflow: 'hidden' }}>
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Galeri</div>
          <h2 className="section-title">
            Sahadan <span className="gradient-text">Görüntüler</span>
          </h2>
          <p className="section-subtitle">
            Gerçek projelerimizden fotoğraf ve video kareler — yapılan işin kalitesini kendiniz görün.
          </p>
        </div>

        {/* Carousel stage */}
        <div
          style={{ position: 'relative', height: '400px', perspective: '1200px', marginBottom: '28px' }}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >

          {ITEMS.map((item, i) => {
            const pos = getPos(i, active);
            const absPos = Math.abs(pos);
            if (absPos > 2) return null;

            const scale = absPos === 0 ? 1 : absPos === 1 ? 0.78 : 0.58;
            const tx = pos * 300;
            const tz = absPos === 0 ? 0 : -120 - absPos * 60;
            const opacity = absPos === 0 ? 1 : absPos === 1 ? 0.7 : 0.4;
            const zIndex = 10 - absPos;
            const rotateY = pos * -8;

            return (
              <div
                key={i}
                onClick={() => handleItemClick(i)}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  width: 'clamp(240px, 75vw, 380px)',
                  aspectRatio: '16/10',
                  transform: `translate(-50%, -50%) translateX(${tx}px) translateZ(${tz}px) rotateY(${rotateY}deg) scale(${scale})`,
                  transition: 'all 0.55s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  zIndex,
                  opacity,
                  cursor: absPos === 0 ? 'zoom-in' : 'pointer',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: absPos === 0
                    ? '0 32px 80px rgba(0,0,0,0.55), 0 0 0 2px rgba(0,180,204,0.5)'
                    : '0 12px 36px rgba(0,0,0,0.35)',
                  background: 'var(--bg-card)',
                  transformStyle: 'preserve-3d',
                }}
              >
                {item.type === 'img' ? (
                  <img
                    src={item.src}
                    alt={item.alt}
                    loading="lazy"
                    decoding="async"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', pointerEvents: 'none' }}
                  />
                ) : (
                  <video
                    src={item.src}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', pointerEvents: 'none' }}
                    preload="metadata"
                    muted
                    playsInline
                  />
                )}

                {/* Active item overlay */}
                {absPos === 0 && (
                  <div style={{
                    position: 'absolute', inset: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 55%)',
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
                    padding: '16px',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ color: 'white', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '0.9rem' }}>
                        {item.type === 'vid' ? '🎬' : '🔍'} {item.caption}
                      </span>
                      <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', fontFamily: 'var(--font-mono)' }}>
                        {active + 1} / {TOTAL}
                      </span>
                    </div>
                    <div style={{ marginTop: '8px', fontSize: '0.75rem', color: 'rgba(0,212,240,0.8)', fontFamily: 'var(--font-mono)' }}>
                      Büyütmek için tıkla
                    </div>
                  </div>
                )}

                {/* Video play badge */}
                {item.type === 'vid' && absPos !== 0 && (
                  <div style={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'rgba(0,0,0,0.5)',
                    borderRadius: '50%', width: '44px', height: '44px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'white', fontSize: '20px',
                  }}>▶</div>
                )}
              </div>
            );
          })}

          {/* Arrows */}
          <button onClick={prev} style={navBtn({ left: 'calc(50% - 220px)' })}>‹</button>
          <button onClick={next} style={navBtn({ right: 'calc(50% - 220px)' })}>›</button>
        </div>

        {/* Dot indicators */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px' }}>
          {ITEMS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              style={{
                width: i === active ? '28px' : '8px',
                height: '8px',
                borderRadius: '4px',
                background: i === active ? 'var(--teal)' : 'rgba(0,180,204,0.2)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s',
                padding: 0,
              }}
            />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.96)',
            zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {/* Prev */}
          <button
            onClick={e => { e.stopPropagation(); setLightbox(l => (l - 1 + TOTAL) % TOTAL); }}
            style={navBtn({ position: 'fixed', left: '20px' })}
          >‹</button>

          {/* Media */}
          <div onClick={e => e.stopPropagation()} style={{ maxWidth: '92vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
            {ITEMS[lightbox].type === 'img' ? (
              <img
                src={ITEMS[lightbox].src}
                alt={ITEMS[lightbox].alt}
                decoding="async"
                style={{
                  maxWidth: '90vw',
                  maxHeight: '80vh',
                  objectFit: 'contain',
                  borderRadius: '14px',
                  display: 'block',
                  boxShadow: '0 40px 100px rgba(0,0,0,0.8)',
                }}
              />
            ) : (
              <video
                key={lightbox}
                src={ITEMS[lightbox].src}
                style={{
                  maxWidth: '90vw',
                  maxHeight: '80vh',
                  borderRadius: '14px',
                  display: 'block',
                  boxShadow: '0 40px 100px rgba(0,0,0,0.8)',
                }}
                controls
                autoPlay
                playsInline
              />
            )}
            <div style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'var(--font-display)', fontSize: '0.9rem', textAlign: 'center' }}>
              {ITEMS[lightbox].caption}
              <span style={{ marginLeft: '12px', fontFamily: 'var(--font-mono)', color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem' }}>
                {lightbox + 1} / {TOTAL}
              </span>
            </div>
          </div>

          {/* Next */}
          <button
            onClick={e => { e.stopPropagation(); setLightbox(l => (l + 1) % TOTAL); }}
            style={navBtn({ position: 'fixed', right: '20px' })}
          >›</button>

          {/* Close */}
          <button
            onClick={() => setLightbox(null)}
            style={{
              position: 'fixed', top: '20px', right: '20px',
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white', fontSize: '18px',
              width: '44px', height: '44px',
              borderRadius: '50%', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              zIndex: 10000,
            }}
          >✕</button>
        </div>
      )}

      <style>{`
        @media (max-width: 700px) {
          .gallery-carousel-stage { height: 260px !important; }
        }
      `}</style>
    </section>
  );
}
